import styled from 'styled-components';

export const ListWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  justify-content: flex-end;
  overflow: hidden;
  width: 100%;

  & > svg {
    flex-shrink: 0;
  }
`;
